const filterEmptyParams = (params) => {
  const newParams = {};
  Object.keys(params).forEach((prop) => {
    if (params[prop] !== '' && params[prop] !== null && params[prop] !== undefined) {
      newParams[prop] = params[prop];
    }
  });
  return newParams;
};

export default filterEmptyParams;

export const isNotNullNorUndefined = (param) => {
  return param !== undefined && param !== null;
};
